// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { TransferItemResponse } from './transfer-item-response';

/** See com.rev360.pms.api.controller.accounting.payment.PaymentTransferInvoiceItemsResponse */
/* istanbul ignore next */
@GandalfModel
export class PaymentTransferInvoiceItemsResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Boolean })
	includeAllItems!: boolean | null;

	@GandalfProperty({ designType: Number })
	payerEntityId!: number | null;

	@GandalfConstantDecorator(constants.PayerType)
	@GandalfProperty({ designType: constants.PayerType })
	payerType!: constants.PayerType | null;

	@GandalfProperty({ designType: Number })
	personInsuranceId!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	transferAmount!: number | null;

	@GandalfArray(TransferItemResponse)
	transferItems!: TransferItemResponse[] | null;

	@GandalfProperty({ designType: Number })
	transferReferenceId!: number | null;

	@GandalfProperty({ designType: Number })
	transferToExistingInvoiceId!: number | null;

	@GandalfConstantDecorator(constants.TransferType)
	@GandalfProperty({ designType: constants.TransferType })
	transferType!: constants.TransferType | null;

	@GandalfProperty({ designType: Number })
	writeoffReferenceId!: number | null;

}
